<template>
  <div class="footer">
    <div class="left">
      <p>Todos os direitos reservados - {{ year }} © Dengo e Arte</p>
    </div>
    <div class="right">
      <p>
        Desenvolvido por
        <a href="https://www.linkedin.com/in/annagabrielac">Anna Gabriela Carvalho</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: #676767;
  color: white;
  padding: 20px;
  text-align: center;
  font-size: 13px;
}

a {
  color: white;
  font-weight: bold;
}
</style>
